<template>
  <div class="drug">
    <el-dialog :visible.sync="dialogVisible" :append-to-body="true" :fullscreen="true" center :modal="mask" :show-close="false">
      <iframe height="100%" width="100%" src="../../../static/js"></iframe>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'drug',
  data() {
    return {
      mask: false,
      dialogVisible: true,
    }
  },
  components: {
    
  }
}
</script>

<style lang="scss" scoped>
.drug {
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/page1/drug.vue